import { setCookie, getCookie } from './cookies';
import getQueryStringParams from './QueryString';

const eligiblePages = ['10e4', '10e5', '10e6'];
const cookieName = 'added to anon';
const sids = [10253998, 10257084];

export default function addAudience() {
    const queryString = getQueryStringParams(location.search);
    const { wid, n, promocode, provider } = queryString;
    const sid = wid / 12345;
    if (sids.includes(sid) && !getCookie(cookieName) && eligiblePages.indexOf(n) != -1) {
        const uid = promocode ? promocode.split('.')[0] : "";
        if (uid) {
            var url = '';

            if (provider === 'mga') {
                url = `https://app.magicapps.tech/api/v3/audience/wjwpcv26/add/${uid}`;
            }

            if (url !== '') {
                fetch(url)
                    .then((response) => {
                        setCookie(cookieName, true, 999);
                    })
                    .catch(() => {
                    });
            }
        }
    }
}